import SenderHeaderContent from '../headers/SenderHeaderContent';
import { PureComponent } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default class TypingHeaderContent extends PureComponent {
  render() {
    const {
      isSenderLoading,
      sender
    } = this.props;
    return /*#__PURE__*/_jsx(SenderHeaderContent, {
      sender: sender,
      isSenderLoading: isSenderLoading
    });
  }
}
TypingHeaderContent.displayName = 'TypingHeaderContent';